import { useEffect, useState } from "react";
import {
    useSubscriptionForCluster,
    useTrackedProjectsInCluster
} from "../contexts/ProjectDataContext";

export const useCanModifyTrackedProjects = (): boolean => {
    const trackedProjects = useTrackedProjectsInCluster();
    const subscription = useSubscriptionForCluster();
    const [canModifyProject, setCanModifyProject] = useState(false);

    useEffect(() => {
        if (
            trackedProjects !== "loading" &&
            subscription !== "loading" &&
            subscription !== undefined
        ) {
            // null in this case means that the subscription has no limit on tracked projects
            if (subscription.projectLimit === null) {
                setCanModifyProject(true);
            } else {
                // Speculative projects count towards the subscription's project limit
                setCanModifyProject(
                    trackedProjects.length < subscription.projectLimit
                );
            }
        }
    }, [trackedProjects, subscription]);

    return canModifyProject;
};
